// src/assets/icons/icon-facebook-logo.tsx
import { jsx } from "react/jsx-runtime";
var IconFacebookLogo = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M185.09 252v241.71a6.29 6.29 0 0 0 6.29 6.29h89.74a6.29 6.29 0 0 0 6.29-6.29V248h65.09a6.29 6.29 0 0 0 6.26-5.75l6.27-74a6.33 6.33 0 0 0-5.78-6.81H287.4V108.9a22.31 22.31 0 0 1 22.3-22.3h50.16a6.28 6.28 0 0 0 6.29-6.28v-74A6.29 6.29 0 0 0 359.86 0H275.1A90 90 0 0 0 185 90v71.41h-44.86a6.28 6.28 0 0 0-6.29 6.29v74a6.28 6.28 0 0 0 6.29 6.29H185Z" })
  }
);
export {
  IconFacebookLogo
};
